import { makeJobsClient } from '@okrapdf/protocol/http-jobs-client';
import { Effect } from 'effect';
import { API_ORIGIN } from '../lib/host';
import { getClerkTokenEffect, restoreClerkTokenBridgeError } from './clerkTokenBridge';

/**
 * [A.6.5a] Singleton `/v1/jobs` client — the typed effect-HttpApi client from
 * the shared contract package, bound to the dashboard's API origin and Clerk
 * token bridge. RTK Query endpoints delegate here so the request/response
 * shape is owned by `@okrapdf/protocol/http-jobs`, not re-declared in-app.
 */
export const jobsClient = makeJobsClient({
  baseUrl: API_ORIGIN,
  getToken: () => Effect.runPromise(restoreClerkTokenBridgeError(getClerkTokenEffect())),
});
